import styled from 'styled-components';

import { borderRadius, palette } from '../theme';
import { modularScale, pxToRem } from '../utils';

/**
 *  ```ts
 *
 * import { Card } from '@ottatech/design'
 *
 * ```
 */

export const Card = styled.div`
  background: ${palette.brand.white};
  border-radius: ${pxToRem(borderRadius)};
  padding: ${modularScale(1)};
`;
